import * as React from 'react';
import { ContextMenuTrigger } from 'react-contextmenu';

const StageTableRow = ({
  stageTableRow,
  setFocusedRow,
  readOnly,
  children,
  ...props
}) => {
  const row = <div {...props}>{children}</div>;

  if (readOnly) {
    return row;
  }

  return (
    <ContextMenuTrigger
      id='project_planning_context_menu'
      holdToDisplay={-1}
      collect={() => {
        setFocusedRow(stageTableRow);

        return stageTableRow;
      }}
    >
      {row}
    </ContextMenuTrigger>
  );
};

export default StageTableRow;
